<template>
  <div>
    <class-summary v-model="maximizeCard" :module_id="49"></class-summary>
    <vx-card title="Filter" class="mb-4">
      <vs-row>
        <vs-col vs-type="flex" vs-lg="10" vs-sm="12">
          <div class="p-1">
            <vs-input placeholder="Search" class="w-full" v-model="search" @keyup="searchFun" style="width: 100%" />
          </div>
          <div class="p-1">
            <vs-input class="w-full" placeholder="Class Name" v-model="filterPayload.class_name" />
          </div>
          <div class="p-1">
            <vs-input class="w-full" placeholder="Term" v-model="filterPayload.term" />
          </div>
          <div class="p-1">
            <v-select :reduce="option => option.id" :getOptionLabel="item => `${item.first_name} ${item.last_name}`"
              style="min-width: 250px;" class="equal_height_select w-full" placeholder="Filter Teacher" :clearable="false"
              @open="onOpenTeacher" @close="onCloseTeacher" :options="teachers_list"
              v-model="filterPayload.class_teacher_id" @search="onTeacherSearch">
              <template v-slot:selected-option="teachers_list">
                <img v-if="teachers_list.picture" class="person-img rounded-full" :src="teachers_list.picture" />
                <img v-else class="person-img rounded-full" src="@/assets/images/pages/user-circle-solid.svg" />
                {{ teachers_list.first_name }}
                {{ teachers_list.last_name }}
              </template>
              <template v-slot:option="teachers_list">
                <img v-if="teachers_list.picture" class="person-img rounded-full" :src="teachers_list.picture" />
                <img v-else class="person-img rounded-full" src="@/assets/images/pages/user-circle-solid.svg" />
                {{ teachers_list.first_name }}
                {{ teachers_list.last_name }}
              </template>
              <template #list-footer>
                <li
                  ref="loadTeacher"
                  class="loader"
                  v-show="teacher_meta.has_next"
                >
                  Loading more teacher...
                </li>
              </template>
            </v-select>
            <!-- <v-select
              style="min-width: 250px;"
              class="w-full"
              placeholder="Search Teachers"
              v-model="filterPayload.class_teacher_id"
              :options="teachers_list"
              :reduce="teacher => teacher.id"
              label="full_name"
              :filterable="false"
              :clearable="false"
              @search="onTeacherSearch"
            >
             <template v-slot:selected-option="teachers_list">
                  <img
                    v-if="teachers_list.picture"
                    class="person-img rounded-full"
                    :src="teachers_list.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ teachers_list.first_name }}
                  {{ teachers_list.last_name }}
                </template>
             <template v-slot:option="teachers_list">
                  <img
                    v-if="teachers_list.picture"
                    class="person-img rounded-full"
                    :src="teachers_list.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ teachers_list.first_name }}
                  {{ teachers_list.last_name }}
                </template>
            </v-select> -->
          </div>
          <div class="p-1">
            <vs-input placeholder="Capacity" v-model="filterPayload.capacity" />
          </div>
          <div class="p-1 inline-flex">
            <vs-button class="includeIcon includeIconOnly mr-1" @click="filterClasses">Go</vs-button>

            <vs-tooltip color="primary" text="Reset Filters" position="top">
              <vs-button type="border" icon-pack="feather" icon="icon-refresh-cw" @click="resetFilters"></vs-button>
            </vs-tooltip>
          </div>
        </vs-col>
        <vs-col v-if="checkCreatePermission()" vs-lg="2" vs-sm="12" class="p-1 text-right">
          <vs-button @click="openCreateModal('Create')">Create</vs-button>
        </vs-col>
      </vs-row>
    </vx-card>
    <vs-tabs v-model="tabIndex" class="unique_cstm_tab">
      <vs-tab label="All Classes">
        <vx-card>
        </vx-card>
      </vs-tab>

      <vs-tab label="Archive Classes">
        <vx-card>
        </vx-card>
      </vs-tab>
    </vs-tabs>
    <vx-card>
      <ag-grid-vue ref="agGridTable" :defaultColDef="defaultColDef" class="ag-theme-material w-100 my-4 ag-grid-table"
        :style="{ height: minHeightClass }"
        :animateRows="true" :floatingFilter="false"
        :paginationPageSize="classesPageLimitSet" :suppressPaginationPanel="true" :enableRtl="$vs.rtl"
        :columnDefs="columnDefs" :rowData="tabIndex === 0 ? class_list : archived_class_list" :gridOptions="gridOptions"
        @grid-ready="onGridReady" @sortChanged="sortFun" />

      <div class="flex flex-wrap justify-between items-center">
      <ItemsPerTableDropdown tableName="unarchived_classes_list"
        @change="pageLimit => (classesPageLimitSet = pageLimit)" />

      <pagination
        :meta="tabIndex === 0 ? class_list_meta : archived_class_list_meta"
        @page-change="handlePagination"
      />
      </div>

    </vx-card>

    <div v-if="certificate_template_modal">
      <vs-popup class="holamundo" title="Share" :active.sync="certificate_template_modal">
        <span v-if="sharedClient.length != 0">
          <h6 class="mb-2">Already Created For Student:</h6>
          <div class="flex flex-wrap mb-4">
            <div class="text-center mr-1" v-for="(selectedUser, index15) in sharedClient" :key="index15">
              <div class="selected-names">
                <!-- <p>{{selectedUser.first_name[0]}}</p> -->
                <img v-if="selectedUser.picture !== null" class="person-img rounded-full shadow-md block"
                  :src="selectedUser.picture" />
                <img v-else class="person-img rounded-full shadow-md block"
                  src="@/assets/images/pages/user-circle-solid.svg" />
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
        </span>
        <span v-if="sharedStaff.length != 0">
          <h6 class="mb-2">Already Created For Staff:</h6>
          <div class="flex flex-wrap mb-4">
            <div class="text-center mr-1" v-for="(selectedUser, index15) in sharedStaff" :key="index15">
              <div class="selected-names">
                <!-- <p>{{selectedUser.first_name[0]}}</p> -->
                <img v-if="selectedUser.picture !== null" class="person-img rounded-full shadow-md block"
                  :src="selectedUser.picture" />
                <img v-else class="person-img rounded-full shadow-md block"
                  src="@/assets/images/pages/user-circle-solid.svg" />
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
        </span>
        <span v-if="selectedStaffs.length != 0">
          <h6 class="mb-4">Shared Staffs :</h6>
          <div class="flex flex-wrap mb-4">
            <div class="text-center mr-1" v-for="(selectedUser, index1) in selectedStaffs" :key="index1">
              <div class="selected-names">
                <img v-if="selectedUser.picture" class="person-img rounded-full" :src="selectedUser.picture" />
                <!-- <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p> -->
                <img v-else class="person-img rounded-full shadow-md block"
                  src="@/assets/images/pages/user-circle-solid.svg" />
                <span @click="closeSelectedUser1(index1)" class="close">&times;</span>
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
          <vs-divider />
        </span>

        <!-- shared with students name -->

        <span v-if="selectedStudents.length != 0">
          <h6 class="mb-4">Shared Students :</h6>
          <div class="flex flex-wrap mb-4">
            <div class="text-center mr-1" v-for="(selectedUser, index2) in selectedStudents" :key="index2">
              <div class="selected-names">
                <!-- <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p> -->
                <img v-if="selectedUser.picture" class="person-img rounded-full" :src="selectedUser.picture" />
                <img v-else class="person-img rounded-full shadow-md block"
                  src="@/assets/images/pages/user-circle-solid.svg" />
                <span @click="closeSelectedUser2(index2)" class="close">&times;</span>
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
          <vs-divider />
        </span>
        <vs-tabs class="cstm_line_tabular_view">
          <vs-tab label="Staffs">
            <vs-table v-if="stafflist" class="checkbox_removed_vstable cstm_vuexy_table" multiple v-model="selectedStaffs"
              :data="stafflist">
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td style="width: 40px;" :data="data[indextr].picture">
                    <img v-if="data[indextr].picture != '' &&
                      data[indextr].picture != null
                      " class="person-img rounded-full shadow-md block" :src="data[indextr].picture" />
                    <img v-else class="person-img rounded-full shadow-md block"
                      src="@/assets/images/pages/user-circle-solid.svg" />
                  </vs-td>
                  <vs-td>
                    <span>
                      {{ data[indextr].first_name }}
                      {{ data[indextr].middle_name }}
                      {{ data[indextr].last_name }}
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <div class="flex flex-wrap justify-between items-center my-4">
              <div>
                <vs-button v-if="currentPageUser > 1" @click="showBackUser" color="primary" icon-pack="feather"
                  icon="icon-chevron-left"></vs-button>
              </div>
              <div class="text-right">
                <vs-button icon-pack="feather" icon="icon-chevron-right" v-if="showButtonUser == true"
                  @click="showMoreUser"></vs-button>
              </div>
            </div>
          </vs-tab>

          <vs-tab label="Students">
            <vs-table v-if="studentsList" class="checkbox_removed_vstable cstm_vuexy_table" multiple
              v-model="selectedStudents" :data="studentsList">
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td style="width: 40px;" :data="data[indextr].picture">
                    <img v-if="data[indextr].picture != ''" class="person-img rounded-full shadow-md block"
                      :src="data[indextr].picture" />
                    <img v-else class="person-img rounded-full shadow-md block"
                      src="@/assets/images/pages/user-circle-solid.svg" />
                  </vs-td>
                  <vs-td>
                    <span>
                      {{ data[indextr].first_name }}
                      {{ data[indextr].middle_name }}
                      {{ data[indextr].last_name }}
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <div class="flex flex-wrap justify-between items-center my-4">
              <div>
                <vs-button v-if="currentPageClient > 1" @click="showBackClient" color="primary" icon-pack="feather"
                  icon="icon-chevron-left"></vs-button>
              </div>
              <div class="text-right">
                <vs-button icon-pack="feather" icon="icon-chevron-right" v-if="showButtonClient == true"
                  @click="showMoreClient"></vs-button>
              </div>
            </div>
          </vs-tab>
          <vs-row>
            <div class="text-right mt-4">
              <vs-button class="block ml-auto mr-2 mt-4" @click="saveAndGenerate('Share')">Generate & Share</vs-button>
            </div>
            <div class="text-right mt-4">
              <vs-button class="block ml-auto mt-4" @click="saveAndGenerate('Save')">Generate & Save</vs-button>
            </div>
          </vs-row>
        </vs-tabs>
      </vs-popup>
    </div>
    <class-create-modal :open="createModalShow" @close="closeCreateModal" @on_data_added="addNewClassData"
      @on_data_updated="updateClassData" :mode="modalMode" :id_to_edit="class_id_edit" />
  </div>
</template>

<script>
import { fetchUserClient } from '@/api/task-project.js'
import Vue from 'vue'
import classSummary from '../analytics/summeryLIst'
import { saveGenerateApi } from '@/api/certificate'
import ClassCreateModal from './components/ClassCreateModal.vue'
import Pagination from '@/components/common/pagination'
import { PaginationData } from '@/mixins/pagination'
import { blog } from '../post-blogs/mixins/blog'
import {
  getClassList,
  searchTeacherList,
  createDuplicate,
  fetchClassUserList,
  archiveClass,
  deleteClass,
  fetchClassBySearch
} from '@/api/classes'
import vSelect from 'vue-select'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { AgGridVue } from 'ag-grid-vue'
import NameCell from './table_components/NameCell.vue'
import ActionCell from './table_components/ActionCell.vue'
// import loadingComponentVue from '../../../components/common/loading-component.vue'

export default {
  name: 'classes',
  components: {
    ClassCreateModal,
    Pagination,
    vSelect,
    classSummary,
    AgGridVue,
    NameCell,
    ActionCell
  },
  // mixins: [PaginationData, blog, PermissionMiddleware],
  mixins: [PermissionMiddleware],
  data () {
    return {
      gridOptions: {
        accentedSort: true
      },
      gridApi: null,
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      tabIndex: 0,
      search: '',
      maximizeCard: true,
      class_id: null,
      selectedStaffs: [],
      selectedStudents: [],
      certificate_template_modal: false,
      customer_id: null,
      createModalShow: false,
      modalMode: '',
      class_id_edit: '',
      class_list: [],
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      class_list_meta: {
        total: '',
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: ''
      },
      archived_class_list: [],
      archived_class_list_meta: {
        total: '',
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: ''
      },
      filterMode: false,
      filterPayload: {
        class_name: '',
        term: '',
        class_teacher_id: '',
        capacity: ''
      },
      teachers_list: [],

      sharedStaff: [],
      sharedClient: [],
      certificate_details: null,
      columnDefs: [
        {
          headerName: 'Class Name',
          field: 'class_name',
          sortable: true,
          cellRendererFramework: Vue.extend(NameCell),
          CellRendererParams: {
            currentTab: () => this.getCurrentTab()
          }
        },
        {
          headerName: 'Term',
          field: 'term',
          valueFormatter: params => params.data.term || '-'
        },
        {
          headerName: 'Class Teacher',
          field: 'class_teacher_name',
          valueFormatter: params => params.data.class_teacher_name.trim() || '-'
        },
        {
          headerName: 'Capacity',
          field: 'capacity',
          valueFormatter: params => params.data.capacity || '-'
        },
        {
          headerName: 'Start Date',
          field: 'start_date',
          valueFormatter: params => this.$options.filters.dateFormatLocalization(
            params.data.start_date
          ) || '-'
        },
        {
          headerName: 'End Date',
          field: 'end_date',
          valueFormatter: params => this.$options.filters.dateFormatLocalization(
            params.data.end_date
          ) || '-'
        },
        {
          headerName: 'Actions',
          field: 'actions',
          sortable: false,
          width: 100,
          cellRendererFramework: Vue.extend(ActionCell),
          CellRendererParams: {
            checkCertificateSharePermission: () => this.checkCertificateSharePermission(),
            checkCreatePermission: () => this.checkCreatePermission(),
            checkEditPermission: () => this.checkEditPermission(),
            checkDeletePermission: () => this.checkDeletePermission(),
            shareClassCertificate: data => this.shareClassCertificate(data),
            duplicateClassData: class_id => this.duplicateClassData(class_id),
            openCreateModal: (type, class_id) => this.openCreateModal(type, class_id),
            openArchiveModal: (class_id, state) => this.openArchiveModal(class_id, state),
            openDeleteModal: class_id => this.openDeleteModal(class_id),
            currentTab: () => this.getCurrentTab()
          }
        }
      ],
      classesPageLimitSet: null,
      // archivedClassesPageLimitSet: null,
      observerTeacher: new IntersectionObserver(this.loadMoreTeacher),
      teacher_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      }
    }
  },
  created () {
    this.customer_id = localStorage.getItem('customer_id')
    //this.checkPermissionForCertificate()
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false
      this.getModulePermission('Class')
    }
    this.getTeacherList()
  },
  computed: {
    archivedClassesPageLimitSet () {
      return this.classesPageLimitSet
    },
    minHeightClass () {
      if (this.tabIndex === 0) {
        return `${(this.class_list.length * 48) + 75 }px`
      } else {
        return `${(this.archived_class_list.length * 48) + 75 }px`
      }
    }
  },
  watch: {
    tabIndex () {
      this.handlePaginationWithRespectToTab()
    },
    classesPageLimitSet () {
      this.handlePaginationWithRespectToTab()
    }
    // archivedClassesPageLimitSet () {
    //   console.log('archieved class page limit set called')
    //   this.handleArchivePageChange(1)
    // }
  },
  methods: {
    handlePaginationWithRespectToTab (page = 1) {
      if (this.tabIndex === 0) {
        this.handlePageChange(page)
      } else {
        this.handleArchivePageChange(page)
      }
    },
    async loadMoreTeacher ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          this.teacher_meta.page = this.teacher_meta.page + 1
          const { data } = await fetchUserClient(
            'User',
            this.customer_id,
            this.teacher_meta
          )
          this.teachers_list.push(...data.data.users_list)
          this.teacher_meta = data.data.meta
          this.teacher_meta.page = data.data.meta.current_page
        } catch (e) {
          //
        }
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async getTeacherList (search) {
      // this.teacher_meta.page = this.teacher_meta.page + 1
      try {
        const { data } = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          { name: search }
        )
        this.teachers_list = data.data.users_list
        this.teacher_meta = data.data.meta
        this.teacher_meta.page = data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    async onOpenTeacher () {
      if (this.teacher_meta.has_next) {
        await this.$nextTick()
        this.observerTeacher.observe(this.$refs.loadTeacher)
      }
    },
    onCloseTeacher () {
      this.observerTeacher.disconnect()
    },
    getCorrectFieldName (colId) {
      let field_name = colId
      if (colId == 'class_name') {
        field_name = 'name'
      } else if (colId == 'class_teacher_name') {
        field_name = 'class_teacher'
      }
      return field_name
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()

        if (sortState.length == 0) {
          console.log('No sort active')
        } else {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = this.getCorrectFieldName(
            sortState[0].colId
          )
          this.sorting_obj.direction = sortState[0].sort

          this.fetchClassListBySearch()
        }
      } catch (e) {
        //
      }
    },
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async vm => {
      await vm.fetchClassListBySearch()
    }, 1500),
    closeSelectedUser1 (index) {
      this.selectedStaffs.splice(index, 1)
    },
    closeSelectedUser2 (index) {
      this.selectedStudents.splice(index, 1)
    },
    async saveAndGenerate (type) {
      const clientNuser = []

      if (this.selectedStudents.length > 0) {
        this.selectedStudents = this.selectedStudents.map(ele => {
          const container = {}
          container.to_user_type = 2
          container.to_user_id = ele.id
          return container
        })
        clientNuser.push(this.selectedStudents)
      }

      if (this.selectedStaffs.length > 0) {
        this.selectedStaffs = this.selectedStaffs.map(ele => {
          const container1 = {}
          container1.to_user_type = 1
          container1.to_user_id = ele.id
          return container1
        })
        clientNuser.push(this.selectedStaffs)
      }
      const payload = {
        class_id: this.class_id,
        title: this.certificate_details.title,
        description: this.certificate_details.description,
        content: this.certificate_details.content,
        type: 2,
        is_shared: type === 'Share' ? 1 : 0,
        template_id: this.certificate_details.certificate_template_id,
        userArray: clientNuser.flat(2),
        certificate_image_id: this.certificate_details.certificate_image_details
          .certificate_image_id
      }
      const data = await saveGenerateApi(
        payload,
        this.$store.getters.customerId
      )
      this.generateCertificatePopup = false
      this.$vs.notify({
        title: 'Success',
        text: `Certificate generated & ${type}d successfully`,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 2000
      })

      this.selectedStaffs = null
      this.selectedStudents = null
      this.certificate_template_modal = false
    },
    async shareClassCertificate (details) {
      if (details.certificate_template_id === null) {
        this.showSuccessMessage(
          'Error',
          'Please Choose a certificate template',
          'danger'
        )
      } else {
        const payload = {
          class_id: details.class_id
        }
        this.class_id = details.class_id
        const data = await fetchClassUserList(payload, this.customer_id)
        this.sharedStaff = details.class_certificate_template.shared_user
        this.sharedClient =
          details.class_certificate_template.shared_client_user
        this.certificate_details = details.class_certificate_template
        // this.shareCourseId = data.id
        if (this.sharedClient.length > 0) {
          this.studentsList = data.data.data.class_client_list
          this.sharedClient.forEach(element => {
            this.studentsList = this.studentsList.filter(
              item => item.id !== element.id
            )
          })
        } else {
          this.studentsList = data.data.data.class_client_list
        }

        if (this.sharedStaff.length > 0) {
          this.stafflist = data.data.data.class_staff_list
          this.sharedStaff.forEach(element => {
            this.stafflist = this.stafflist.filter(
              item => item.id !== element.id
            )
          })
        } else {
          this.stafflist = data.data.data.class_staff_list
        }

        //debugger
        this.certificate_template_modal = true
      }
    },
    openCreateModal (mode, class_id) {
      this.modalMode = mode

      if (mode === 'Edit') {
        this.class_id_edit = class_id
      }

      this.createModalShow = true
    },
    closeCreateModal () {
      this.modalMode = ''
      this.class_id_edit = ''
      this.createModalShow = false
    },
    async filterClasses () {
      this.filterMode = true
      this.getAllClassList(1, this.filterPayload)
    },
    resetFilters () {
      this.search = null
      this.filterPayload = {
        class_name: '',
        term: '',
        class_teacher_id: '',
        capacity: ''
      }

      this.filterMode = false

      this.getAllClassList(1)
    },
    getCurrentTab () {
      return this.tabIndex
    },
    handlePagination (page) {
      this.handlePaginationWithRespectToTab(page)
    },
    handlePageChange (page) {
      if (!this.classesPageLimitSet) return

      if (this.filterMode && this.search === '') {
        this.getAllClassList(page, this.filterPayload)
      } else if (this.search !== '' || this.sorting_obj.attribute !== '') {
        this.fetchClassListBySearch()
      } else {
        this.getAllClassList(page)
      }
    },
    async fetchClassListBySearch () {
      try {
        const payload = {
          search: this.search,
          customer_id: this.$store.getters.customerId,
          is_archived: this.tabIndex === 0 ? 1 : 0
        }
        this.$vs.loading({
          text: 'Loading...'
        })
        const responseData = await fetchClassBySearch(
          payload,
          this.tabIndex === 0
            ? this.class_list_meta.current_page
            : this.archived_class_list_meta.current_page,
          this.tabIndex === 0
            ? this.classesPageLimitSet
            : this.archivedClassesPageLimitSet,
          this.sorting_obj
        )
        if (this.tabIndex === 0) {
          this.class_list = responseData.data.data.classes
          this.class_list_meta = responseData.data.data.meta
        } else if (this.tabIndex === 1) {
          this.archived_class_list = responseData.data.data.classes
          this.archived_class_list_meta = responseData.data.data.meta
        }
      } catch (e) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    handleArchivePageChange (page) {
      if (!this.archivedClassesPageLimitSet) return

      if (this.search !== '' || this.sorting_obj.attribute != '') {
        this.fetchClassListBySearch()
      } else {
        this.getAllArchivedClassList(page)
      }
    },
    async getAllClassList (page, payload) {
      try {
        const response = await getClassList(
          this.customer_id,
          page,
          { ...payload, is_archived: 1 },
          this.classesPageLimitSet,
          this.sorting_obj
        )
        this.class_list = response.data.data.classes
        this.class_list_meta = response.data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    async getAllArchivedClassList (page, payload) {
      try {
        const response = await getClassList(
          this.customer_id,
          page,
          { ...payload, is_archived: 0 },
          this.archivedClassesPageLimitSet,
          this.sorting_obj
        )
        this.archived_class_list = response.data.data.classes
        this.archived_class_list_meta = response.data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    addNewClassData (data) {
      this.class_list.unshift({ ...data })
    },
    updateClassData (data) {
      const index = this.class_list.findIndex(
        item => item.class_id === data.class_id
      )
      this.class_list.splice(index, 1, data)
    },
    async onTeacherSearch (search, loading) {
      if (search.length > 2) {
        loading(true)
        this.searchTeacher(loading, search, this)
      }
    },
    // eslint-disable-next-line no-undef
    searchTeacher: _.debounce(async (loading, search, vm) => {
      const customer_id = vm.$store.getters.customerId

      try {
        // Fetch the response from search query
        const { data } = await fetchUserClient(
          'User',
          customer_id,
          vm.teacher_meta,
          { name: search }
        )
        vm.teachers_list = data.data.users_list
        vm.teacher_meta = data.data.meta
        vm.teacher_meta.page = data.data.meta.current_page
        loading(false)
      } catch (e) {
        console.log(e)
      }
    }, 350),
    async duplicateClassData (class_id) {
      try {
        const response = await createDuplicate({
          class_id,
          customer_id: this.customer_id
        })

        this.addNewClassData({ ...response.data.data.classes })
        this.showSuccessMessage('Success', response.data.message, 'success')
      } catch (e) {
        console.log(e)
        this.showSuccessMessage('Error', e.data.message, 'danger')
      }
    },
    openDeleteModal (class_id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text:
          'Are you sure you want to permanently delete this class? This change is irreversible.',
        accept: this.deleteClass,
        parameters: class_id
      })
    },
    openArchiveModal (class_id, archive_type) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: `Are you sure you want to ${archive_type === 0 ? 'archive' : 'unarchive'
        } this class?`,
        accept: this.archiveClass,
        parameters: { class_id, archive_type }
      })
    },
    async archiveClass ({ class_id, archive_type }) {
      const payload = {
        customer_id: this.customer_id,
        class_id,
        is_archived: archive_type
      }

      try {
        const response = await archiveClass(payload)
        if (response.status === 202) {
          if (archive_type === 0) {
            const index = this.class_list.findIndex(
              item => item.class_id === class_id
            )

            if (index > -1) {
              this.class_list.splice(index, 1)

              if (
                this.class_list.length === 0 &&
                !this.class_list_meta.next_page_url
              ) {
                this.handlePageChange(this.class_list_meta.current_page - 1)
              } else {
                this.handlePageChange(this.class_list_meta.current_page)
              }
            }

            this.showSuccessMessage(
              'Success',
              'Class archived successfully',
              'success'
            )
          }

          if (archive_type === 1) {
            const index = this.archived_class_list.findIndex(
              item => item.class_id === class_id
            )

            if (index > -1) {
              this.archived_class_list.splice(index, 1)

              if (
                this.archived_class_list.length === 0 &&
                !this.archived_class_list_meta.next_page_url
              ) {
                this.handleArchivePageChange(
                  this.archived_class_list_meta.current_page - 1
                )
              } else {
                this.handleArchivePageChange(
                  this.archived_class_list_meta.current_page
                )
              }
            }

            this.showSuccessMessage(
              'Success',
              'Class unarchived successfully',
              'success'
            )
          }
        }
      } catch (e) {
        this.showSuccessMessage('Error', e.data.message, 'danger')
      }
    },
    async deleteClass (class_id) {
      const payload = {
        class_ids: [class_id]
      }

      try {
        const response = await deleteClass(this.customer_id, payload)
        if (response.status === 202) {
          const index = this.archived_class_list.findIndex(
            item => item.class_id === class_id
          )

          if (index > -1) {
            this.archived_class_list.splice(index, 1)

            if (
              this.archived_class_list.length === 0 &&
              !this.archived_class_list_meta.next_page_url
            ) {
              this.handleArchivePageChange(
                this.archived_class_list_meta.current_page - 1
              )
            } else {
              this.handleArchivePageChange(
                this.archived_class_list_meta.current_page
              )
            }
          }

          this.showSuccessMessage(
            'Success',
            'Class deleted successfully',
            'success'
          )
        }
      } catch (e) {
        this.showSuccessMessage('Error', e.data.message, 'danger')
      }
    }
  }
}
</script>
